<script setup>
import { computed } from "vue";

/* Mini bar list (donut replacement) — ported from the design MBars.
   Each item: { label, v, pct?, c }. Rows with a non-"Other" label become
   clickable when an onPick handler is supplied. */
const props = defineProps({
  items: { type: Array, default: () => [] },
  max: { type: Number, default: 0 },
});
const emit = defineEmits(["pick"]);

const mx = computed(
  () => props.max || Math.max(1, ...props.items.map((i) => Number(i.v) || 0)),
);
const pickable = (it) => !/^Other/.test(it.label);
</script>

<template>
  <div>
    <div
      v-for="(it, i) in items"
      :key="i"
      class="btm-barrow"
      :style="pickable(it) ? { cursor: 'pointer' } : null"
      @click="pickable(it) && emit('pick', it.label)"
    >
      <div class="lab">
        <span class="d" :style="{ background: it.c }" />
        <span class="tx">{{ it.label }}</span>
      </div>
      <div class="met">
        {{ Number(it.v).toLocaleString()
        }}<span
          v-if="it.pct != null"
          style="color: var(--text-3); margin-left: 5px"
          >{{ it.pct }}%</span
        >
      </div>
      <div class="track">
        <div
          class="fill"
          :style="{ width: (Number(it.v) / mx) * 100 + '%', background: it.c }"
        />
      </div>
    </div>
  </div>
</template>
